import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-col"
};
const _hoisted_3 = { class: "flex flex-col gap-6" };
const _hoisted_4 = { class: "flex flex-col divide-y divide-(--colors-border-base)" };
const _hoisted_5 = { class: "flex items-center gap-2 text-sm min-w-0" };
const _hoisted_6 = { class: "leading-snug" };
const _hoisted_7 = {
    key: 1,
    class: "text-sm text-(--colors-text-secondary)"
};
const _hoisted_8 = { class: "flex flex-col gap-3" };
const _hoisted_9 = {
    type: "button",
    disabled: "",
    class: "flex w-full items-center justify-between px-4 py-3.5 rounded-xl border border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) opacity-50 cursor-not-allowed transition-colors"
};
const _hoisted_10 = { class: "flex items-center gap-3 text-sm font-medium" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "flex items-center gap-3 text-sm font-medium" };
const _hoisted_13 = { class: "flex flex-col gap-6" };
const _hoisted_14 = {
    key: 0,
    class: "flex flex-col items-center py-4 gap-3"
};
const _hoisted_15 = { class: "relative w-36 h-36" };
const _hoisted_16 = {
    viewBox: "0 0 36 36",
    class: "w-full h-full -rotate-90"
};
const _hoisted_17 = ["stroke", "stroke-dasharray", "stroke-dashoffset"];
const _hoisted_18 = { class: "absolute inset-0 flex flex-col items-center justify-center" };
const _hoisted_19 = { class: "text-base font-bold leading-tight" };
const _hoisted_20 = { class: "text-xs text-(--colors-text-secondary)" };
const _hoisted_21 = { class: "flex flex-col gap-1 text-xs w-full" };
const _hoisted_22 = { class: "truncate text-(--colors-text-secondary)" };
const _hoisted_23 = { class: "ml-auto font-medium" };
const _hoisted_24 = {
    key: 1,
    class: "py-6 text-center text-sm text-(--colors-text-secondary)"
};
const _hoisted_25 = {
    key: 0,
    class: "flex flex-col gap-3 py-2"
};
const _hoisted_26 = { class: "flex items-end justify-center gap-4 h-40" };
const _hoisted_27 = { class: "flex-1 flex flex-col items-center justify-end gap-1 h-full" };
const _hoisted_28 = { class: "text-xs font-semibold text-(--colors-text-heading)" };
const _hoisted_29 = { class: "flex-1 flex flex-col items-center justify-end gap-1 h-full" };
const _hoisted_30 = { class: "text-xs font-semibold text-(--colors-text-heading)" };
const _hoisted_31 = { class: "flex justify-center gap-4" };
const _hoisted_32 = { class: "flex-1 text-center text-sm font-medium text-(--colors-text-body)" };
const _hoisted_33 = { class: "flex-1 text-center text-sm font-medium text-(--colors-text-body)" };
const _hoisted_34 = {
    key: 0,
    class: "flex items-center justify-center gap-1.5 text-sm"
};
const _hoisted_35 = { class: "text-(--colors-text-body)" };
const _hoisted_36 = {
    key: 1,
    class: "py-6 text-center text-sm text-(--colors-text-secondary)"
};
const _hoisted_37 = { class: "grid grid-cols-2 gap-3" };
const _hoisted_38 = { class: "flex flex-col items-center text-center gap-1 px-3 py-3 rounded-xl border border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)" };
const _hoisted_39 = { class: "text-base font-bold leading-tight" };
const _hoisted_40 = { class: "text-xs text-(--colors-text-secondary)" };
const _hoisted_41 = { class: "flex flex-col items-center text-center gap-1 px-3 py-3 rounded-xl border border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)" };
const _hoisted_42 = { class: "text-base font-bold leading-tight" };
const _hoisted_43 = { class: "text-xs text-(--colors-text-secondary)" };
const _hoisted_44 = { class: "flex flex-col items-center text-center gap-1 px-3 py-3 rounded-xl border border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)" };
const _hoisted_45 = { class: "text-base font-bold leading-tight" };
const _hoisted_46 = { class: "text-xs text-(--colors-text-secondary)" };
const _hoisted_47 = { class: "flex flex-col items-center text-center gap-1 px-3 py-3 rounded-xl border border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)" };
const _hoisted_48 = { class: "text-base font-bold leading-tight" };
const _hoisted_49 = { class: "text-xs text-(--colors-text-secondary)" };
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { Accordion, AccordionItem, Button, DatePickerInput, SelectInput, TextInput, Timeline, Tooltip, WidgetShell, } from "@eudonet/opal";
import { RouterLink } from "vue-router";
import { useDonationOptions } from "../../composables/useDonationOptions";
import { useFinanceFormatters } from "@/shared/composables/useFinanceFormatters";
import { useProfileStore } from "../../../../settings/stores/useProfileStore";
import { formatDateTime, isoToDisplayDate, toDatePickerFormat, } from "@/shared/utils/date-formatting";
import { historyActionLabel, historyFieldLabel, historyValueLabel } from "../../composables/historyLabels";
import { useHistoryDateFormatters } from "../../composables/useHistoryDateFormatters";
import { buildContactRoute, buildOrganisationRoute } from "../../composables/donorRoute";
import { useSubscriptionOptions } from "../../composables/useSubscriptionOptions";
import { fetchSubscription } from "../../../infrastructure/adapters/subscriptionService";
import { logger } from "@/infrastructure/services/LoggerService";
const MAX_BAR_PERCENT = 80;
const COMPARISON_PREVIOUS_COLOR = "#00d3f2"; // cyan — "Précédent" bar (Figma)
const COMPARISON_CURRENT_COLOR = "#4f39f6"; // indigo-600 — "Actuel" bar (Figma)
const RECENT_ACTIVITY_LIMIT = 5;
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationTabResume',
    props: {
        state: {},
        sectionOpen: {},
        history: {},
        loading: { type: Boolean, default: false },
        donorStats: {},
        allocations: { default: () => [] },
        isFullyAllocated: { type: Boolean, default: false },
        locked: { type: Boolean, default: false }
    },
    emits: ["navigateToHistory", "addAllocation", "addComment", "navigateToTaxReceipt"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function onQuickAction(key) {
            // OP-5845: defense in depth — the allocation action's button is also natively disabled.
            if (key === "allocation") {
                if (props.isFullyAllocated || props.locked)
                    return;
                emit("addAllocation");
            }
            else if (key === "comment")
                emit("addComment");
        }
        // The "Issue tax receipt" recommendation routes to the Reçu fiscal tab so the user can
        // generate (or review) the receipt there.
        function onRecommendationAction(key) {
            if (key === "rec1")
                emit("navigateToTaxReceipt");
        }
        // Donor link target. The donor resolves to a CRM contact (Individual) or organisation
        // (Organization) — never to `donorId`, which is OPDON's own donor key and is NOT a valid
        // /contacts/:id. Returns null when the CRM reference isn't available, so the donor name
        // renders as plain text instead of a link that 404s.
        const donorRoute = computed(() => {
            const { donorType, contactId, organizationId } = props.state;
            if (donorType === "Organization" && organizationId) {
                return { name: "Organisation", params: { id: organizationId } };
            }
            if (contactId) {
                return { name: "ContactDetail", params: { id: contactId } };
            }
            return null;
        });
        // OP-5843: an Organisation donation shows two donor rows — the organisation and its referent
        // contact ("Contact référent"). Each links to its own CRM record. Null when the reference is
        // missing, so the value renders as plain text instead of a link that 404s.
        const organisationRoute = computed(() => buildOrganisationRoute(props.state.organizationId));
        const contactRoute = computed(() => buildContactRoute(props.state.contactId));
        const { t, locale } = useI18n();
        const profileStore = useProfileStore();
        // Campaign type label (OP-5162). The donation carries the OPINK catalog code; render it through
        // the shared `campaignType.{code}.title` key used by the Communication module. Empty when the
        // type has not synced from OPINK yet, so the disabled field renders blank rather than a raw code.
        const campaignTypeLabel = computed(() => props.state.campaignType ? t(`campaignType.${props.state.campaignType}.title`) : "");
        // Subscription business label. The Resume tab carries only the technical subscriptionId, so fetch
        // the linked subscription and build "donor — amount / frequency" via the SAME `toOption` the picker
        // uses (useSubscriptionOptions), guaranteeing the label matches the selection list. A sequence
        // token guards against a stale fetch resolving after a fast donation-to-donation switch.
        const { toOption } = useSubscriptionOptions();
        const subscriptionLabel = ref("");
        let subscriptionFetchSeq = 0;
        watch(() => [props.state.donationType, props.state.subscriptionId], async ([type, id]) => {
            subscriptionLabel.value = "";
            if (type !== "Regular" || !id)
                return;
            const requestId = ++subscriptionFetchSeq;
            try {
                const subscription = await fetchSubscription(id);
                if (requestId === subscriptionFetchSeq)
                    subscriptionLabel.value = toOption(subscription).label;
            }
            catch (err) {
                logger.error("DonationTabResume: failed to load linked subscription label", err);
            }
        }, { immediate: true });
        const { statusOptions, donationTypeOptions, paymentMethodLabelOptions, paymentMethodOptionsFor, donationNatureOptions, donationFormOptions, donationSourceOptions, } = useDonationOptions();
        const recordPaymentMethodOptions = paymentMethodOptionsFor(() => [props.state.paymentMethod]);
        const { formatAmount, formatDate } = useFinanceFormatters();
        const historyDateFormatters = useHistoryDateFormatters();
        // Donation date is stored ISO (`yyyy-MM-dd`); render it through OPAL's DatePickerInput
        // in the user's display format — same bridge as DonationCreateModal / DonationTabDetails.
        // Binding the raw stored instant with no `format` makes flowbite misparse it into
        // garbage like "10/06/0178" (OP-5819).
        const dateFormat = computed(() => toDatePickerFormat(profileStore.profile?.dateFormat, locale.value));
        const donationDateDisplay = computed(() => isoToDisplayDate(props.state.donationDate, profileStore.profile?.dateFormat, locale.value));
        // ── Comparaison avec don précédent (OP-5094) ─────────────────────────────────
        // Bars are scaled to the taller of the two amounts; cap the tallest at 80% of the
        // chart height so the amount label above it always has room (no overflow).
        const comparison = computed(() => {
            const current = props.state.amount ?? 0;
            const previous = props.state.previousDonationAmount;
            const hasPrevious = previous != null;
            const max = Math.max(previous ?? 0, current, 1);
            return {
                hasPrevious,
                current,
                previous: previous ?? 0,
                previousHeight: `${((previous ?? 0) / max) * MAX_BAR_PERCENT}%`,
                currentHeight: `${(current / max) * MAX_BAR_PERCENT}%`,
            };
        });
        // Trend line below the bars: arrow + percentage in success/error colour. Null when there
        // is no variation to show (first donation, or a previous amount of 0). The arrow conveys
        // direction, so the percentage is rendered unsigned (matches Figma).
        const trend = computed(() => {
            const variation = props.state.donationTrendPercentage;
            if (variation == null)
                return null;
            const text = new Intl.NumberFormat(locale.value, {
                style: "percent",
                maximumFractionDigits: 2,
                signDisplay: "never",
            }).format(Math.abs(variation) / 100);
            if (variation > 0) {
                return { icon: "ri-arrow-up-line", colorClass: "text-(--colors-text-success-strong)", text };
            }
            if (variation < 0) {
                return { icon: "ri-arrow-down-line", colorClass: "text-(--colors-text-error-strong)", text };
            }
            return { icon: "", colorClass: "text-(--colors-text-body)", text };
        });
        // ── Chart-series colours ─────────────────────────────────────────────────────
        // OPAL exposes only semantic colour tokens — it has no categorical data-visualisation palette —
        // so chart series use intentional literals: the Figma-specified comparison bars plus a rotating
        // palette for the allocation donut. Centralised here (rather than scattered `bg-[#hex]` classes)
        // so a future DS data-viz palette is a single-spot swap.
        const ALLOCATION_COLORS = [
            "#06b6d4",
            "#a78bfa",
            "#fb923c",
            "#34d399",
            "#f472b6",
            "#facc15",
            "#60a5fa",
        ];
        // ── Répartition du don (affectations) ────────────────────────────────────────
        // Donut + legend driven by the donation's real allocations. Each segment's stroke-dasharray is
        // "{pct} {100-pct}" on the ~100-circumference circle (r=15.9), offset by the cumulative prior %.
        const allocationSegments = computed(() => {
            const total = props.state.amount ?? 0;
            let cumulative = 0;
            return props.allocations.map((allocation, index) => {
                const pct = allocation.percentage ?? (total > 0 ? (allocation.allocatedAmount / total) * 100 : 0);
                const segment = {
                    key: allocation.allocationId,
                    label: allocation.projectName || t("finance.donations.detail.alloc.project"),
                    percent: Math.round(pct * 10) / 10,
                    color: ALLOCATION_COLORS[index % ALLOCATION_COLORS.length],
                    dash: `${pct} ${100 - pct}`,
                    offset: -cumulative,
                };
                cumulative += pct;
                return segment;
            });
        });
        const allocatedPercent = computed(() => Math.round(allocationSegments.value.reduce((sum, s) => sum + s.percent, 0) * 10) / 10);
        // ── Activité récente — most recent audit entries as an OPAL Timeline ──────────
        // Reuses the History tab's field/value localization so an entry reads identically
        // in both places. Same enum-option lists as DonationTabHistory.
        const valueOptionsByField = computed(() => ({
            TransactionStatus: statusOptions.value,
            PaymentMethod: paymentMethodLabelOptions.value,
            DonationNature: donationNatureOptions.value,
            DonationForm: donationFormOptions.value,
            DonationSource: donationSourceOptions.value,
            DonationType: donationTypeOptions.value,
        }));
        const recentActivityItems = computed(() => [...props.history]
            .filter((entry) => entry.entityType !== "DonationComment")
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .slice(0, RECENT_ACTIVITY_LIMIT)
            .map((entry) => {
            // Donation field-diff rows carry a concrete `field` and show "field : value"; lifecycle/summary
            // rows (allocation, receipt — Created AND Updated) have an empty `field` and use the action
            // label. Branching on `field` (not `operation`) keeps allocation *Updated* rows from rendering
            // blank.
            let title;
            if (!entry.field) {
                title = historyActionLabel(t, entry.entityType, entry.operation);
            }
            else {
                const field = historyFieldLabel(t, entry.field);
                const value = entry.valueIcon
                    ? ""
                    : historyValueLabel(entry.field, entry.value, valueOptionsByField.value, props.state.currency ? (amount) => formatAmount(amount, props.state.currency) : undefined, historyDateFormatters);
                title = value ? `${field} : ${value}` : field;
            }
            return {
                date: formatDateTime(entry.date, locale.value, profileStore.profile?.dateFormat, profileStore.profile?.timeFormat),
                // Figma uses one consistent badge colour for every entry; pin the theme so the
                // Timeline doesn't cycle through its default palette (green/violet/yellow/…).
                badgeTheme: "cyan",
                icon: "ri-calendar-line",
                title,
                description: entry.author?.trim() || t(`finance.donations.detail.history.source.${entry.source}`),
            };
        }));
        // Tax receipts don't apply to Regular (subscription-linked) donations, so the "Issue tax receipt"
        // recommendation is hidden ONLY for those — and shown for every other donation type. Eligibility
        // is type-based (the same rule as the Reçu fiscal tab's `isRegularDonation` guard); it is
        // intentionally NOT gated on the donation status or on an already-issued receipt.
        const isTaxReceiptEligible = computed(() => props.state.donationType !== "Regular");
        const recommendations = computed(() => isTaxReceiptEligible.value
            ? [
                {
                    key: "rec1",
                    icon: "ri-file-text-line",
                    labelKey: "finance.donations.detail.rec1",
                    actionKey: "finance.donations.detail.rec1Action",
                },
            ]
            : []);
        // OP-5845: "fully allocated" is computed once in DonationDetailView from the BE-authoritative
        // totalUnallocated and passed to both tabs, so the Resume quick action and the Allocations Add
        // button can never disagree. The allocation action is also disabled once an issued receipt locks
        // Affectation (same rule as the Allocations tab); the lock reason takes priority over the
        // fully-allocated reason.
        const quickActions = computed(() => [
            {
                key: "allocation",
                icon: "ri-pie-chart-line",
                labelKey: "finance.donations.detail.addAllocation",
                disabled: props.locked || props.isFullyAllocated,
                tooltipKey: props.locked
                    ? "finance.donations.taxReceipt.lockedByReceipt"
                    : "finance.donations.detail.alloc.fullyAllocatedTooltip",
            },
            {
                key: "comment",
                icon: "ri-chat-1-line",
                labelKey: "finance.donations.detail.addComment",
                disabled: false,
                tooltipKey: "",
            },
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(WidgetShell), { flush: "" }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(Accordion), {
                            variant: "flush",
                            multiple: true,
                            "heading-level": 2
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(AccordionItem), {
                                    title: _ctx.$t('finance.donations.sections.information'),
                                    "default-open": true
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(TextInput), {
                                            label: _ctx.$t('finance.donations.fields.netAmount'),
                                            "model-value": String(__props.state.amount),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["label", "model-value"]),
                                        _createVNode(_unref(SelectInput), {
                                            "model-value": __props.state.donationType,
                                            label: _ctx.$t('finance.donations.fields.donationType'),
                                            options: _unref(donationTypeOptions),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["model-value", "label", "options"]),
                                        (__props.state.donationType === 'Regular')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                _createVNode(_unref(TextInput), {
                                                    "model-value": subscriptionLabel.value || (__props.state.subscriptionId ? '…' : '–'),
                                                    label: _ctx.$t('finance.donations.fields.subscriptionId'),
                                                    disabled: true,
                                                    "data-testid": "donation-resume-subscription-label",
                                                    "full-width": ""
                                                }, null, 8 /* PROPS */, ["model-value", "label"]),
                                                (__props.state.subscriptionId)
                                                    ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                        key: 0,
                                                        to: { name: 'SubscriptionDetail', params: { subscriptionId: __props.state.subscriptionId } },
                                                        class: "-mt-3 mb-2 inline-flex w-fit items-center gap-1 text-sm font-medium text-(--text-text-link) hover:text-(--text-text-hover) transition-colors",
                                                        "data-testid": "donation-resume-subscription-link"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-external-link-line" }, null, -1 /* CACHED */)),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t("finance.donations.detail.viewSubscription")), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["to"]))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createVNode(_unref(SelectInput), {
                                            "model-value": __props.state.natureDon ?? '',
                                            label: _ctx.$t('finance.donations.fields.natureDon'),
                                            options: _unref(donationNatureOptions),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["model-value", "label", "options"]),
                                        (__props.state.donationForm)
                                            ? (_openBlock(), _createBlock(_unref(SelectInput), {
                                                key: 1,
                                                "model-value": __props.state.donationForm,
                                                label: _ctx.$t('finance.donations.fields.donationForm'),
                                                options: _unref(donationFormOptions),
                                                disabled: true,
                                                "full-width": ""
                                            }, null, 8 /* PROPS */, ["model-value", "label", "options"]))
                                            : _createCommentVNode("v-if", true),
                                        (__props.state.donationSource)
                                            ? (_openBlock(), _createBlock(_unref(SelectInput), {
                                                key: 2,
                                                "model-value": __props.state.donationSource,
                                                label: _ctx.$t('finance.donations.fields.donationSource'),
                                                options: _unref(donationSourceOptions),
                                                disabled: true,
                                                "full-width": ""
                                            }, null, 8 /* PROPS */, ["model-value", "label", "options"]))
                                            : _createCommentVNode("v-if", true),
                                        _createVNode(_unref(SelectInput), {
                                            "model-value": __props.state.paymentMethod,
                                            label: _ctx.$t('finance.donations.fields.paymentMethod'),
                                            options: _unref(recordPaymentMethodOptions),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["model-value", "label", "options"]),
                                        (__props.state.paymentMethod === 'Cheque')
                                            ? (_openBlock(), _createBlock(_unref(TextInput), {
                                                key: 3,
                                                label: _ctx.$t('finance.donations.fields.chequeNumber'),
                                                "model-value": __props.state.chequeNumber ?? '',
                                                disabled: true,
                                                "full-width": ""
                                            }, null, 8 /* PROPS */, ["label", "model-value"]))
                                            : _createCommentVNode("v-if", true),
                                        _createVNode(_unref(DatePickerInput), {
                                            "model-value": donationDateDisplay.value,
                                            label: _ctx.$t('finance.donations.fields.donationDate'),
                                            format: dateFormat.value,
                                            language: _unref(locale),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["model-value", "label", "format", "language"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]),
                                _createVNode(_unref(AccordionItem), {
                                    title: _ctx.$t('finance.donations.sections.donor'),
                                    "default-open": true
                                }, {
                                    default: _withCtx(() => [
                                        (__props.state.donorType === 'Organization')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (organisationRoute.value)
                                                    ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                        key: 0,
                                                        to: organisationRoute.value,
                                                        class: "block",
                                                        "aria-label": `${_ctx.$t('finance.donations.fields.orgName')}: ${__props.state.donorName}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(TextInput), {
                                                                "model-value": __props.state.donorName,
                                                                label: _ctx.$t('finance.donations.fields.orgName'),
                                                                disabled: true,
                                                                "value-variant": "link",
                                                                "full-width": ""
                                                            }, null, 8 /* PROPS */, ["model-value", "label"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["to", "aria-label"]))
                                                    : (_openBlock(), _createBlock(_unref(TextInput), {
                                                        key: 1,
                                                        "model-value": __props.state.donorName,
                                                        label: _ctx.$t('finance.donations.fields.orgName'),
                                                        disabled: true,
                                                        "full-width": ""
                                                    }, null, 8 /* PROPS */, ["model-value", "label"])),
                                                (contactRoute.value)
                                                    ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                        key: 2,
                                                        to: contactRoute.value,
                                                        class: "block",
                                                        "aria-label": `${_ctx.$t('finance.donations.fields.donorContact')}: ${__props.state.contactDisplayName ?? ''}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(TextInput), {
                                                                "model-value": __props.state.contactDisplayName ?? '',
                                                                label: _ctx.$t('finance.donations.fields.donorContact'),
                                                                disabled: true,
                                                                "value-variant": "link",
                                                                "full-width": ""
                                                            }, null, 8 /* PROPS */, ["model-value", "label"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["to", "aria-label"]))
                                                    : (_openBlock(), _createBlock(_unref(TextInput), {
                                                        key: 3,
                                                        "model-value": __props.state.contactDisplayName ?? '',
                                                        label: _ctx.$t('finance.donations.fields.donorContact'),
                                                        disabled: true,
                                                        "full-width": ""
                                                    }, null, 8 /* PROPS */, ["model-value", "label"]))
                                            ], 64 /* STABLE_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (donorRoute.value)
                                                    ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                        key: 0,
                                                        to: donorRoute.value,
                                                        class: "block",
                                                        "aria-label": `${_ctx.$t('finance.donations.fields.donorContact')}: ${__props.state.donorName}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(TextInput), {
                                                                "model-value": __props.state.donorName,
                                                                label: _ctx.$t('finance.donations.fields.donorContact'),
                                                                disabled: true,
                                                                "value-variant": "link",
                                                                "full-width": ""
                                                            }, null, 8 /* PROPS */, ["model-value", "label"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["to", "aria-label"]))
                                                    : (_openBlock(), _createBlock(_unref(TextInput), {
                                                        key: 1,
                                                        "model-value": __props.state.donorName,
                                                        label: _ctx.$t('finance.donations.fields.donorContact'),
                                                        disabled: true,
                                                        "full-width": ""
                                                    }, null, 8 /* PROPS */, ["model-value", "label"]))
                                            ], 64 /* STABLE_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]),
                                _createVNode(_unref(AccordionItem), {
                                    title: _ctx.$t('finance.donations.sections.campaign'),
                                    "default-open": true
                                }, {
                                    default: _withCtx(() => [
                                        (__props.state.campaignId)
                                            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                key: 0,
                                                to: { name: 'CampaignDetail', params: { id: __props.state.campaignId } },
                                                class: "block",
                                                "aria-label": `${_ctx.$t('finance.donations.fields.campaignLinked')}: ${__props.state.campaignName ?? ''}`
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(TextInput), {
                                                        label: _ctx.$t('finance.donations.fields.campaignLinked'),
                                                        "model-value": __props.state.campaignName ?? '',
                                                        disabled: true,
                                                        "value-variant": "link",
                                                        "full-width": ""
                                                    }, null, 8 /* PROPS */, ["label", "model-value"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["to", "aria-label"]))
                                            : (_openBlock(), _createBlock(_unref(TextInput), {
                                                key: 1,
                                                label: _ctx.$t('finance.donations.fields.campaignLinked'),
                                                "model-value": __props.state.campaignName ?? '',
                                                disabled: true,
                                                "full-width": ""
                                            }, null, 8 /* PROPS */, ["label", "model-value"])),
                                        (__props.state.campaignId)
                                            ? (_openBlock(), _createBlock(_unref(TextInput), {
                                                key: 2,
                                                label: _ctx.$t('finance.donations.fields.campaignType'),
                                                "model-value": campaignTypeLabel.value,
                                                disabled: true,
                                                "full-width": ""
                                            }, null, 8 /* PROPS */, ["label", "model-value"]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createElementVNode("div", _hoisted_3, [
                    (recommendations.value.length > 0)
                        ? (_openBlock(), _createBlock(_unref(WidgetShell), {
                            key: 0,
                            header: _ctx.$t('finance.donations.detail.recommendations')
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendations.value, (rec) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: rec.key,
                                            class: "flex items-center justify-between gap-3 py-3 first:pt-0 last:pb-0"
                                        }, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass([rec.icon, "text-base leading-none text-(--colors-primary) shrink-0"])
                                                }, null, 2 /* CLASS */),
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(rec.labelKey)), 1 /* TEXT */)
                                            ]),
                                            _createVNode(_unref(Button), {
                                                variant: "secondary",
                                                size: "sm",
                                                label: _ctx.$t(rec.actionKey),
                                                "icon-right": "ri-arrow-right-line",
                                                class: "shrink-0",
                                                onClick: ($event) => (onRecommendationAction(rec.key))
                                            }, null, 8 /* PROPS */, ["label", "onClick"])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["header"]))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_unref(WidgetShell), {
                        header: _ctx.$t('finance.donations.detail.recentActivity')
                    }, {
                        footer: _withCtx(() => [
                            _createElementVNode("button", {
                                class: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#919191] bg-white dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) text-xs font-medium text-(--colors-text-default) hover:border-(--colors-primary) hover:text-(--colors-primary) transition-colors cursor-pointer",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('navigateToHistory')))
                            }, [
                                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ri-eye-fill text-sm" }, null, -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("finance.donations.detail.seeAllHistory")), 1 /* TEXT */)
                            ])
                        ]),
                        default: _withCtx(() => [
                            (__props.loading || recentActivityItems.value.length > 0)
                                ? (_openBlock(), _createBlock(_unref(Timeline), {
                                    key: 0,
                                    items: recentActivityItems.value,
                                    loading: __props.loading,
                                    orientation: "vertical",
                                    "aria-label": _ctx.$t('finance.donations.detail.recentActivity')
                                }, null, 8 /* PROPS */, ["items", "loading", "aria-label"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("finance.donations.detail.history.empty")), 1 /* TEXT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["header"]),
                    _createVNode(_unref(WidgetShell), {
                        header: _ctx.$t('finance.donations.detail.quickActions')
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickActions.value, (action) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: action.key
                                    }, [
                                        (action.disabled)
                                            ? (_openBlock(), _createBlock(_unref(Tooltip), {
                                                key: 0,
                                                text: _ctx.$t(action.tooltipKey),
                                                position: "top",
                                                tabindex: 0,
                                                class: "w-full"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("button", _hoisted_9, [
                                                        _createElementVNode("div", _hoisted_10, [
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass([action.icon, "text-lg text-(--colors-text-secondary)"])
                                                            }, null, 2 /* CLASS */),
                                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(action.labelKey)), 1 /* TEXT */)
                                                        ]),
                                                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ri-arrow-right-line text-base text-(--colors-text-secondary)" }, null, -1 /* CACHED */))
                                                    ])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"]))
                                            : (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "button",
                                                class: "flex items-center justify-between px-4 py-3.5 rounded-xl border border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) hover:border-(--colors-primary) hover:bg-(--colors-background-white-secondary) dark:hover:bg-white/5 transition-colors",
                                                onClick: ($event) => (onQuickAction(action.key))
                                            }, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass([action.icon, "text-lg text-(--colors-text-secondary)"])
                                                    }, null, 2 /* CLASS */),
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(action.labelKey)), 1 /* TEXT */)
                                                ]),
                                                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ri-arrow-right-line text-base text-(--colors-text-secondary)" }, null, -1 /* CACHED */))
                                            ], 8 /* PROPS */, _hoisted_11))
                                    ], 64 /* STABLE_FRAGMENT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["header"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(WidgetShell), {
                        header: _ctx.$t('finance.donations.detail.donationShare')
                    }, {
                        default: _withCtx(() => [
                            (allocationSegments.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                                            _cache[5] || (_cache[5] = _createElementVNode("circle", {
                                                cx: "18",
                                                cy: "18",
                                                r: "15.9",
                                                fill: "none",
                                                stroke: "#f3f4f6",
                                                "stroke-width": "3.8"
                                            }, null, -1 /* CACHED */)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allocationSegments.value, (seg) => {
                                                return (_openBlock(), _createElementBlock("circle", {
                                                    key: seg.key,
                                                    cx: "18",
                                                    cy: "18",
                                                    r: "15.9",
                                                    fill: "none",
                                                    stroke: seg.color,
                                                    "stroke-width": "3.8",
                                                    "stroke-dasharray": seg.dash,
                                                    "stroke-dashoffset": seg.offset
                                                }, null, 8 /* PROPS */, _hoisted_17));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(allocatedPercent.value) + "%", 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("finance.donations.detail.allocated")), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allocationSegments.value, (seg) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: seg.key,
                                                class: "flex items-center gap-1.5"
                                            }, [
                                                _createElementVNode("span", {
                                                    class: "w-2.5 h-2.5 rounded-full shrink-0",
                                                    style: _normalizeStyle({ backgroundColor: seg.color })
                                                }, null, 4 /* STYLE */),
                                                _createElementVNode("span", _hoisted_22, _toDisplayString(seg.label), 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(seg.percent) + "%", 1 /* TEXT */)
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t("finance.donations.detail.alloc.empty")), 1 /* TEXT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["header"]),
                    _createVNode(_unref(WidgetShell), {
                        header: _ctx.$t('finance.donations.detail.previousComparison')
                    }, {
                        default: _withCtx(() => [
                            (comparison.value.hasPrevious)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(formatAmount)(comparison.value.previous, __props.state.currency)), 1 /* TEXT */),
                                            _createElementVNode("div", {
                                                class: "w-full rounded-t-sm",
                                                style: _normalizeStyle({
                                                    height: comparison.value.previousHeight,
                                                    backgroundColor: COMPARISON_PREVIOUS_COLOR,
                                                })
                                            }, null, 4 /* STYLE */)
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(formatAmount)(comparison.value.current, __props.state.currency)), 1 /* TEXT */),
                                            _createElementVNode("div", {
                                                class: "w-full rounded-t-sm",
                                                style: _normalizeStyle({
                                                    height: comparison.value.currentHeight,
                                                    backgroundColor: COMPARISON_CURRENT_COLOR,
                                                })
                                            }, null, 4 /* STYLE */)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("finance.donations.detail.previous")), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("finance.donations.detail.current")), 1 /* TEXT */)
                                    ]),
                                    (trend.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass([trend.value.colorClass, "inline-flex items-center gap-0.5 font-medium"])
                                            }, [
                                                (trend.value.icon)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: _normalizeClass(trend.value.icon),
                                                        "aria-hidden": "true"
                                                    }, null, 2 /* CLASS */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(" " + _toDisplayString(trend.value.text), 1 /* TEXT */)
                                            ], 2 /* CLASS */),
                                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("finance.donations.detail.vsPreviousDonation")), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.$t("finance.donations.detail.noPreviousDonation")), 1 /* TEXT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["header"]),
                    _createVNode(_unref(WidgetShell), {
                        header: _ctx.$t('finance.donations.detail.donorStats')
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(formatAmount)(__props.donorStats.totalDonations, __props.donorStats.currency)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("finance.donations.detail.totalDonations")), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(__props.donorStats.donationCount), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("finance.donations.detail.donationCount")), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(formatAmount)(__props.donorStats.averageDonation, __props.donorStats.currency)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("finance.donations.detail.averageDonation")), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(formatDate)(__props.donorStats.firstDonationDate)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("finance.donations.detail.firstDonation")), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["header"])
                ])
            ]));
        };
    }
});
